import React from 'react';
import { Button } from '../components/Button';
import { LogoMark } from '../components/LogoMark';
interface WhyMGSProps {
  onDownload: () => void;
}
export function WhyMGS({
  onDownload
}: WhyMGSProps) {
  return <section id="about" className="w-full scroll-mt-20 bg-cream py-20 lg:py-28" data-id="element-684">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-12 lg:items-center lg:px-8" data-id="element-685">
        <div className="lg:col-span-7" data-id="element-686">
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-warmgray" data-id="element-687">
            <LogoMark className="h-3.5 w-3.5" data-id="element-688" /> Why MGS exists
          </p>
          <h2 className="mt-3 text-3xl font-black leading-[1.1] tracking-tight text-charcoal sm:text-4xl" data-id="element-689">
            Built for geologists who want to do the work properly.
          </h2>
          <div className="mt-5 space-y-4 text-base leading-relaxed text-warmgray" data-id="element-690">
            <p data-id="element-691">
              Jordan Biglin is building Mine Geology Systems to help geologists
              think clearly about systems — not just isolated technical tasks.
              Most geology problems on site aren't really about the rocks.
              They're about how inputs, interpretation, decisions and feedback
              hang together.
            </p>
            <p data-id="element-692">
              MGS is a practical framework, a growing resource library and a
              community for geologists who care about doing the work properly.
              Better geology outcomes need better systems, not just better
              judgement in isolation.
            </p>
          </div>
          <div className="mt-7" data-id="element-693">
            <Button variant="secondary" as="a" href="#about" data-id="element-694">
              Read Jordan's Story
            </Button>
          </div>
        </div>

        <div className="lg:col-span-5" data-id="element-695">
          <div className="rounded-2xl border border-charcoal/10 bg-sand p-7" data-id="element-696">
            <p className="text-xs font-bold uppercase tracking-widest text-warmgray" data-id="element-697">
              Principles
            </p>
            <ul className="mt-4 space-y-3" data-id="element-698">
              {['Clarity beats complexity', 'Inputs shape decisions', 'Interpretation needs structure', 'Feedback should change future work', 'Improvement must be deliberate', 'Systems are built by people, not documents alone'].map(p => <li key={p} className="flex items-start gap-3 text-sm font-medium text-charcoal" data-id="element-699">
                  <LogoMark className="mt-0.5 h-4 w-4 shrink-0" data-id="element-700" />
                  {p}
                </li>)}
            </ul>
            <button type="button" onClick={onDownload} className="mt-6 w-full rounded-md border border-charcoal/15 bg-cream px-4 py-3 text-sm font-bold text-charcoal hover:bg-charcoal/5" data-id="element-701">
              Or just grab the free guide →
            </button>
          </div>
        </div>
      </div>
    </section>;
}